import { Component, Input } from '@angular/core'
import { environment } from '@tv3/environments/environment'
import { Router } from '@angular/router'
import { getLocale } from '@tv3/utils/functions/get-locale'

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss'],
})
export class LoginLayoutComponent {
  @Input() imageUrl: string

  constructor(private router: Router) {}

  languages = environment.languages

  onLanguageChange(lang: string) {
    const currentUrl = this.router.url.split('/').slice(1).join('/') // Remove language prefix
    window.location.href = `/${lang}/${currentUrl}`
  }

  isActiveLang(lang: string) {
    const locale = getLocale()

    return lang === locale
  }
}
